var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlossary = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4078A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.99364,
    d: "M48.924 25c0 13.213-10.711 23.924-23.924 23.924S1.076 38.213 1.076 25 11.787 1.076 25 1.076 48.924 11.787 48.924 25z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.99364,
    d: "M25 17.873c0-2.12 5.12-3.838 11.962-3.838v18.093C30.12 32.128 25 33.846 25 35.965c0-2.119-5.12-3.837-11.962-3.837V14.035C19.88 14.035 25 15.753 25 17.873zM25.25 18.022v17.943"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlossary);
export default ForwardRef;